<template>
	<div class=" white-bg pad20">
		<copyrighthead :actives="0"></copyrighthead>
		<h3 class="mt20">签章原件</h3>
		<div class="mt10">
			<el-upload action="https://jsonplaceholder.typicode.com/posts/" list-type="picture-card"
				:on-preview="handlePictureCardPreview" :on-remove="handleRemove">
				<i class="el-icon-plus"></i>
			</el-upload>
			<el-dialog :visible.sync="dialogVisible">
				<img width="100%" :src="dialogImageUrl" alt="">
			</el-dialog>
		</div>
		<div class="d-gray mt10">
			<span>请上传jpg、png、jpeg、pdf格式，上传签章原件 </span>
			<el-tooltip class="item" effect="dark" content="下载说明,仅供参考" placement="bottom">
				<i class="el-icon-aim cur_brand"></i>
			</el-tooltip>
		</div>
		<div class="mt20 appwidth">
			<div>申请人委托代理人办理登记事宜，具体委托事项如下：</div>
			<div class="mt10">
				<el-input v-model="applyVal" placeholder="作品著作权登记申请"></el-input>
			</div>
		</div>
		<div class="hr"></div>
		<div class="mt20">
			<el-button type="success" @click="appNext">下一步</el-button>
		</div>
	</div>
</template>

<script>
	import copyrighthead from '../../components/CopyRightHead.vue'
	export default {
		name: 'uploadPower',
		components: {
			copyrighthead
		},
		data() {
			return {
				dialogImageUrl: '',
				dialogVisible: false,
				applyVal: ''
			}

		},
		created() {},
		updated() {},
		methods: {
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			appNext() {
				this.$router.push({
					name: '/creationInformation',
					params: {
						userId: 123
					}
				})
			}
		}
	}
</script>
<style lang="scss" scoped>
	.appwidth {
		width: 340px;
	}
</style>
